module.exports = __webpack_public_path__ + "img/pp-05.9b2fdbe2.jpg";